import { Injectable,Component } from '@angular/core';
import { HttpHeaders}  from '@angular/common/http';  
import { Observable,throwError  } from 'rxjs';  
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { Profile } from 'selenium-webdriver/firefox';
import { MockResourceLoader } from '@angular/compiler/testing';

export class Registration {
  
  PhysicalDisabilityID:number;
  StudentTitle:string;
  StuPoartlaID: number;
  StudeMailId: string;
  FirstName:string;
  LastName:  string;
  MiddleName: string;
  StuGender:  string;
  MobileNo:  string;
  EmailID:  string;
  StudentMothersName: string;
  StudentBirtHDate: string;
  Password:  string;
  CollegeID:number;
  StudentID:number;
  MoblieOTP: string;
  EmailOTP:  string;
  Question1A:  string;
  Question2A:  string;
  Question3A:  string;
  Question4A:  string;
  Question5A:  string;
  confirmPassword:string;
  PreExamOtpId:Number;
  StudentRegType:string;
  PRNNO:string;
  UniverSityPRNNO:string;  
  StudentName:string;
  ExternalFlag:string;
}
export class Gender{
  Name:string;
  shortName:string;
}
let genders:Gender[]=[
  {
    "Name":"Male",
    "shortName":"M"
  },
  {
    "Name":"Female",
    "shortName":"F"
  },
  {
    "Name":"Transgender",
    "shortName":"T"
  }]
  export class RegistrationType{
    Name:string;
    shortName:string;
  }
  let registrationType:RegistrationType[]=[
    {
      "Name":"Readmission",
      "shortName":"R"
    },
    {
      "Name":"Registered Student(PG)",
      "shortName":"C"
    }]
@Injectable(
  {  
    providedIn: 'root'  
  }
)
@Component({
  providers: [DataAccessService]
})
export class RegistrationService {

  constructor(
    private dataService: DataAccessService) {
  }

  public save(data) {debugger
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'PostInsertPortalStudentLogIn'; // setting method name from API controller.
    return this.dataService.add<Registration[]>(data) 
  }
public GenerateMobOTP(MobileNo,CollegeID){debugger
  this.dataService.setControllerName = '/PortalStudentLogIn/';
  this.dataService.setMethodName ='GetGenerateSMSOTP?MobileNo='+MobileNo + '&CollegeID=' + CollegeID + ''; 
  return this.dataService.getAll<Registration[]>()
}
public GenerateEmailOTP(MobileNo,EmailID,OTPid,CollegeID){debugger
  this.dataService.setControllerName = '/PortalStudentLogIn/';
  this.dataService.setMethodName = 'GetGenerateEmailOTP?MobileNo='+MobileNo+'&StudeMailId='+EmailID+'&PreExamOTPId='+OTPid+'&CollegeID='+ CollegeID + ''; 
  return this.dataService.getAll<Registration[]>()
}
public VerifyMobOTP(MobileNo,mobOTP,CollegeID){debugger
  this.dataService.setControllerName = '/PortalStudentLogIn/';
  this.dataService.setMethodName = 'GetVerifyMobileOtp?MobileNo='+MobileNo+'&MoblieOTP='+mobOTP+'&CollegeID=' + CollegeID + ''; 
  return this.dataService.getAll<Registration[]>()
}

public VerifyDuplicateMob(MobileNo,CollegeID){debugger
  this.dataService.setControllerName = '/PortalStudentLogIn/';
  this.dataService.setMethodName = 'GetMobileExist?MobileNo='+MobileNo+ '&CollegeID=' + CollegeID + ''; 
  return this.dataService.getAll<Registration[]>()
}
public VerifyDuplicateEmail(EmailID){debugger
  this.dataService.setControllerName = '/PortalStudentLogIn/';
  this.dataService.setMethodName = 'GetEmailExist?EmailID='+EmailID; 
  return this.dataService.getAll<Registration[]>()
}
public VerifyEmailOTP(MobileNo,EmailID,emailOTP,CollegeID){debugger
  this.dataService.setControllerName = '/PortalStudentLogIn/';
  this.dataService.setMethodName = 'GetVerifyEmailOtp?MobileNo='+MobileNo+'&StudeMailId='+EmailID+'&EmailOTP='+emailOTP+'&CollegeID=' + CollegeID +''; 
  return this.dataService.getAll<Registration[]>()
}
public VerifyAge(data){debugger
  this.dataService.setControllerName = '/PreExamOtp/';
  this.dataService.setMethodName = 'GetYearDiffrence?anydate='+data.StudentBirtHDate+''; 
  return this.dataService.getAll<Registration[]>()
}
public GetCheckPRNCount(PRNNO){debugger
  this.dataService.setControllerName = '/PortalStudentLogIn/';
  this.dataService.setMethodName = 'GetCheckPRNCount?PRNNO='+PRNNO+''; 
  return this.dataService.getAll<Registration[]>()
}

public GetStudentByUniverSityPRNNO(UniverSityPRNNO){debugger
  this.dataService.setControllerName = '/PreStudentInformation/';
  this.dataService.setMethodName = 'GetStudentByUniverSityPRNNO?UniverSityPRNNO='+UniverSityPRNNO+''; 
  return this.dataService.getAll<Registration[]>()
}

public CheckEmailDuplicate(StudeMailId){debugger
  this.dataService.setControllerName = '/PortalStudentLogIn/';
  this.dataService.setMethodName = 'CheckEmailDuplicate?StudeMailId='+StudeMailId+''; 
  return this.dataService.getAll<Registration[]>()
}
  public getGenders(){
    return genders;
  }
  public getRegistrationType(){
    return registrationType;
  }
}
